package meineglasfaser.frontend.common.components.widgets

import meineglasfaser.api.IncidentLevel
import meineglasfaser.api.IncidentStatus

val INCIDENT_LEVEL_STRINGS = mapOf(
    IncidentLevel.UNKNOWN to "Unbekannt",
    IncidentLevel.DEGRADED to "Eingeschränkte Leistung",
    IncidentLevel.PARTIAL to "Teilausfall",
    IncidentLevel.MAJOR to "Vollausfall",
)

val INCIDENT_STATUS_STRINGS = mapOf(
    IncidentStatus.REPORTED to "Gemeldet",
    IncidentStatus.INVESTIGATING to "Wird untersucht",
    IncidentStatus.IDENTIFIED to "Ursache identifiziert",
    IncidentStatus.WATCHING to "Wird beobachtet",
    IncidentStatus.FIXED to "Behoben",
)
